import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './reset.css';
import './app.css';
import './assets/fonts/onest/font.css';
import './assets/styles/variables.css';
import './assets/styles/form.css';

import { Provider } from "react-redux";
import { createStore, applyMiddleware } from 'redux';
import reducer from "./redux/reducer";
import createSagaMiddleware from 'redux-saga';

import watcherGetBooking from "./redux/sagas/getBookingSaga";
import watcherSendBooking from "./redux/sagas/sendBookingSaga";
import watcherRegistration from "./redux/sagas/registrationSaga";
import watcherCheckEmailCode from "./redux/sagas/checkEmailCodeSaga";
import watcherRecoveryPassword from "./redux/sagas/recoveryPasswordSaga";
import watcherGetFilters from "./redux/sagas/getFiltersSaga";
import watcherSignIn from "./redux/sagas/signInSaga";
import watcherCheckHash from "./redux/sagas/checkHashSaga";
import watcherGetSubscriptions from "./redux/sagas/getSubscriptionsSaga";
import watcherBookingAction from "./redux/sagas/bookingActionSaga";
import watcherGetServices from "./redux/sagas/getServicesSaga";
import watcherGetMasters from "./redux/sagas/getMastersSaga";
import watcherGetTimetable from "./redux/sagas/getTimetableSaga";
import watcherAddScheduleReserve from "./redux/sagas/addScheduleReserveSaga";
import watcherGetMyReserves from "./redux/sagas/getMyReservesSaga";
import watcherRemoveReserve from "./redux/sagas/removeResreveSaga";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(watcherGetBooking);
sagaMiddleware.run(watcherSendBooking);
sagaMiddleware.run(watcherRegistration);
sagaMiddleware.run(watcherCheckEmailCode);
sagaMiddleware.run(watcherRecoveryPassword);
sagaMiddleware.run(watcherGetFilters);
sagaMiddleware.run(watcherSignIn);
sagaMiddleware.run(watcherCheckHash);
sagaMiddleware.run(watcherGetSubscriptions);
sagaMiddleware.run(watcherBookingAction);
sagaMiddleware.run(watcherGetServices);
sagaMiddleware.run(watcherGetMasters);
sagaMiddleware.run(watcherGetTimetable);
sagaMiddleware.run(watcherAddScheduleReserve);
sagaMiddleware.run(watcherGetMyReserves);
sagaMiddleware.run(watcherRemoveReserve);

const root = ReactDOM.createRoot(document.querySelector('.layout'));
root.render(
    <Provider store={ store } >
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </Provider>
);